var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.formContainer },
    [
      _c(
        "LoginCard",
        { attrs: { header: "Administrator MFA Reset", showCustomLogo: false } },
        [
          _vm.errorMessage
            ? _c("Alert", {
                model: {
                  value: _vm.errorMessage,
                  callback: function ($$v) {
                    _vm.errorMessage = $$v
                  },
                  expression: "errorMessage",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isExpired
            ? _c(
                "Alert",
                {
                  attrs: { centered: "" },
                  on: { updateMessage: _vm.handleHideExpiredAlert },
                },
                [
                  _c("p", { class: _vm.$style.alertHeader }, [
                    _vm._v(
                      "\n        This MFA reset link has expired.\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { class: _vm.$style.alertText }, [
                    _vm._v(
                      "\n        Check your inbox for the most recent link or reset your TOTP\n        again. For security purposes, this link expires after 24 hours.\n      "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form",
            { class: _vm.$style.form },
            [
              _c("LoginTextField", {
                attrs: {
                  autoFocus: _vm.autofocus === "email",
                  label: "Email",
                  name: "email",
                  placeholder: "Administrator Email Address",
                  required: "",
                  submitOnEnter: _vm.submit,
                  isEditable: false,
                  type: "email",
                  vvName: "email",
                },
                on: {
                  focus: function ($event) {
                    return _vm.updateAutofocus("email")
                  },
                },
                model: {
                  value: _vm.form.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email",
                },
              }),
              _vm._v(" "),
              _c("LoginTextField", {
                attrs: {
                  label: "Password",
                  name: "password",
                  placeholder: "Password",
                  rules: { max: 64, required: true },
                  type: "password",
                  vvName: "password",
                  submitOnEnter: _vm.submit,
                },
                model: {
                  value: _vm.form.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "password", $$v)
                  },
                  expression: "form.password",
                },
              }),
              _vm._v(" "),
              _c(
                "LoginActionButton",
                {
                  attrs: {
                    action: _vm.request,
                    isLoading: _vm.isLoading,
                    disabled: _vm.isDisabled,
                  },
                },
                [_vm._v("\n        Set Up MFA\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("LogoIcon"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }